import { FormEvent, ReactNode, useEffect, useState } from 'react'

import { ErrorList } from '../../components/common'
import styles from './AuthLayout.module.scss'

const PAGE_BACKGROUND = '#f9f9fb'

export function AuthLayout({ children }: { children: ReactNode }) {
  useEffect(() => {
    const previous = document.body.style.backgroundColor
    document.body.style.backgroundColor = PAGE_BACKGROUND
    return () => {
      document.body.style.backgroundColor = previous
    }
  }, [])

  return (
    <div id="div_for_yield" className="container" style={{ width: '100%' }}>
      {children}
    </div>
  )
}

export function AuthLogo({ narrow = false }: { narrow?: boolean }) {
  return (
    <div className="row">
      <div className={`col-xs-12 text-center ${styles.logoBlock}`}>
        <a>
          <img src="/logo_letra_nuevo.png" className={`img-responsive ${narrow ? styles.logoNarrow : styles.logo}`} alt="Historia Clínica" />
        </a>
      </div>
    </div>
  )
}

export function AuthAlerts({ notices, errors }: { notices: readonly string[]; errors: readonly string[] }) {
  const [dismissed, setDismissed] = useState<readonly string[]>([])
  const visible = (messages: readonly string[]) => messages.filter(Boolean).filter((message) => !dismissed.includes(message))
  const dismiss = (message: string) => setDismissed((current) => [...current, message])

  return (
    <>
      <ErrorList messages={visible(errors)} kind="danger" onDismiss={dismiss} />
      <ErrorList messages={visible(notices)} kind="success" onDismiss={dismiss} />
    </>
  )
}

/** The narrow card the four single-field auth screens share. */
export function LoginForm({ onSubmit, children }: { onSubmit: (event: FormEvent) => void; children: ReactNode }) {
  return (
    <div className={styles.loginForm}>
      <form role="login" className={styles.form} onSubmit={onSubmit}>
        {children}
      </form>
    </div>
  )
}
